import styled from "styled-components";

export const Wrapper = styled.div`
  max-width: 480px;
  margin: 40px auto;
  padding: 0 20px;
  font-family: "Iosevka Charon", monospace;
`;

export const Title = styled.h1`
  font-family: "Titillium Web", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: #192a2aff;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const Subtitle = styled.h2`
  font-family: "Titillium Web", sans-serif;
  font-size: 26px;
  font-weight: 600;
  color: #192a2aff;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
